export default __webpack_public_path__ + "static/media/html.172bda11.svg";